 <template>
  <div id="app">
    <div class="app-info">
      <!-- <div class="app-info-s">
        <div class="app-info-logo">
          <img src="../../assets/img/app-jisuanqi@2x.png" alt />
        </div>
        <div class="app-info-content">
          <span class="app-name">智能计算器</span>
          <br />
          <span class="app-desc">
            -伪装成计算器，人畜无害
            <br />-但消息推送过于频繁可能引起怀疑
          </span>
          <br />
          <button @click="jisuan();upclick(1)">立即下载使用</button>
        </div>
        <div class="app-info-right">免费</div>
      </div>-->

      <div v-show="appflag" class="clac-s">
        <ul class="info-s">
          <li v-for="item in appList">
            <div>
              <img class="info-log" :src="item.logo" alt />
              <button v-if="item.type == 1" @click="jisuanc(item.type)">{{item.name}}</button>
              <button
                class="nunbutton"
                style="background: #ddd;color:#aaa"
                disabled="disabled"
                v-if="item.type == 10"
              >{{item.name}}</button>
            </div>
            <div class="info-jb">
              <img :src="item.img" alt />
            </div>
          </li>
        </ul>
      </div>

      <div v-show="appflag" class="new-s">
        <ul class="info-s">
          <li v-for="item in newList">
            <div>
              <img class="info-log" :src="item.logo" alt />
              <div v-if="iosflag">
              <button v-if="item.type == 1" @click="news(item.type)">{{item.name}}</button>
              <button
                class="nunbutton"
                style="background: #ddd;color:#aaa"
                disabled="disabled"
                v-if="item.type != 1"
              >{{item.name}}</button>
              </div>
              <div v-if="!iosflag">
              <button v-if="item.type != 10" @click="news(item.type)">{{item.name}}</button>
              <button
                class="nunbutton"
                style="background: #ddd;color:#aaa"
                disabled="disabled"
                v-if="item.type == 10"
              >{{item.name}}</button>
              </div>

            </div>
            <div class="info-jb">
              <img :src="item.img" alt />
            </div>
          </li>
        </ul>
      </div>

      <!-- 待开发 -->
      <div class="dkf">
        <div class="app-info-s dkf-s">
          <div class="app-info-logo">
            <img src="../../assets/img/app-abc@2x.png" alt />
          </div>
          <div class="app-info-content">
            <span class="app-name">背单词APP</span>
            <br />
            <span class="app-desc">
              -伪装成背单词APP，真的可以学习英语
              <br />-有新消息时推送单词考题
              <br />-积极向上的好学人设
            </span>
            <br />
            <button @click="shangxian();upclick(3)">即将上线</button>
          </div>
          <div class="app-info-right">VIP专享</div>
        </div>

        <div class="app-info-s">
          <div class="app-info-logo">
            <img src="../../assets/img/app-game@2x.png" alt />
          </div>
          <div class="app-info-content">
            <span class="app-name">游戏APP</span>
            <br />
            <span class="app-desc">
              -伪装成游戏APP
              <br />-有新消息时推送领金币
              <br />-聊天时遇紧急情况，秒切至游戏页面
            </span>
            <button @click="shangxian();upclick(4)">即将上线</button>
          </div>
          <div class="app-info-right">VIP专享</div>
        </div>
      </div>
      <!-- 待开发 -->
    </div>
  </div>
</template>
<script>
import tips from "@/estoast";
import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import api from "../../api/index";

export default {
  name: "app",
  data() {
    return {
      msg: "注册协议",
      appList: [
        {
          logo: "http://img.haoyunba.com/1-putong.png",
          img: "http://img.haoyunba.com/mainfei.png",
          name: "下载智能计算器",
          type: 1
        },
        {
          logo: "http://img.haoyunba.com/2-xiaomi.png",
          img: "http://img.haoyunba.com/vip-j.png",
          name: "下载小米专用",
          type: 10
        },
        {
          logo: "http://img.haoyunba.com/3-pingguo.png",
          img: "http://img.haoyunba.com/vip-j.png",
          name: "下载苹果专用",
          type: 10
        },

        {
          logo: "http://img.haoyunba.com/4-vivo.png",
          img: "http://img.haoyunba.com/vip-j.png",
          name: "下载vivo专用",
          type: 10
        },

        {
          logo: "http://img.haoyunba.com/5-oppo.png",
          img: "http://img.haoyunba.com/vip-j.png",
          name: "下载OPPO专用",
          type: 10
        },
        {
          logo: "http://img.haoyunba.com/6-huawei.png",
          img: "http://img.haoyunba.com/vip-j.png",
          name: "下载华为专用",
          type: 10
        }
      ],

      newList: [
        {
          logo: "http://img.haoyunba.com/news-txs.png",
          img: "http://img.haoyunba.com/vip-j.png",

          name: "天下事",
          type: 1
        },
        {
          logo: "http://img.haoyunba.com/news-dd.png",
          img: "http://img.haoyunba.com/vip-j.png",
          name: "多点资讯",
          type: 2
        },
        {
          logo: "http://img.haoyunba.com/news-hk.png",
          img: "http://img.haoyunba.com/vip-j.png",
          name: "好看资讯",
          type: 3
        },

        {
          logo: "http://img.haoyunba.com/news-nm.png",
          img: "http://img.haoyunba.com/vip-j.png",
          name: "柠檬新闻",
          type: 4
        },

        {
          logo: "http://img.haoyunba.com/news-jd.png",
          img: "http://img.haoyunba.com/vip-j.png",
          name: "新闻焦点",
          type: 5
        },
        {
          logo: "http://img.haoyunba.com/news-sd.png",
          img: "http://img.haoyunba.com/vip-j.png",
          name: "新闻速递",
          type: 6
        }
      ],
      appflag: false,
      iosflag:false
    };
  },
  created() {
    
     let u = navigator.userAgent;
    let iOs = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端\
    if(iOs){
      this.iosflag = true;
    }
    this.iosflag

    this.$axiosHttp({
      method: "POST",
      url: api.qml.getAppSatus,
      data: {}
    })
      .then(res => {
        if (res.code == 0) {
          if (res.result == 0) {
            this.appflag = true;
          }
        } else {
          tips.toast(res.message);
        }
      })
      .catch(err => {
        tips.toast(err);
        console.log(err);
      });
  },
  methods: {
    upclick: function(tag) {
      this.$point.eventtag(tag, "btn_100008");
    },
    jisuan: function() {
      this.$point.eventId("btn_100008");

      this.$router.push("/userAppInfo?token=" + this.getToken);
    },
    jisuanc: function(a) {
      this.$point.eventId("btn_100008");

      if (a == 1) {
        this.$router.push("/userAppInfo?token=" + this.getToken);
        return;
      }

      tips.toast("即将上线，敬请期待");
      return;
    },
    jisuan: function() {
      this.$point.eventId("btn_100008");

      this.$router.push("/userAppInfo?token=" + this.getToken);
    },
    shangxian: function() {
      tips.toast("即将上线，敬请期待");
    },
    news(a) {
      if (a == 1) {
        this.toNews();
        return;
      }
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        tips.toast("即将上线，敬请期待");
        return;
      }
      //多点资讯
      if (a == 2) {
        window.location.href =
          "http://wap.haoyunba.com/apk/news/news_ddzx_android_V1.1.0.apk";
        return;
      }
      //好看资讯
      if (a == 3) {
        window.location.href =
          "http://wap.haoyunba.com/apk/news/news_hkzx_android_V1.1.0.apk";
        return;
      }
      //柠檬新闻
      if (a == 4) {
        window.location.href =
          "http://wap.haoyunba.com/apk/news/news_nmxw_android_V1.1.0.apk";
        return;
      }
      //新闻焦点
      if (a == 5) {
        window.location.href =
          "http://wap.haoyunba.com/apk/news/news_xwjd_android_V1.1.0.apk";
        return;
      }
      //新闻速递
      if (a == 6) {
        window.location.href =
          "http://wap.haoyunba.com/apk/news/news_xwsd_android_V1.1.0.apk";
        return;
      }

      tips.toast("即将上线，敬请期待");
    },
    toNews: function() {
      /*
      var userInfo = this.getUserInfo;
      if (userInfo.viptype > 0) {
        //判断是否过期
        var nowtime = new Date();
        var validitydate = new Date(userInfo.validitydate);
        if (validitydate < nowtime) {
          tips.toast("您的会员已经过期");
          return;
        } else {
          if (navigator.userAgent.indexOf("Android") > -1) {
            // tips.toast("即将上线，敬请期待");
            this.$point.eventId("down_app_news_100001");
            window.location =
              "http://news.haoyunba.com/apk/news_android.apk";
          } else {
            this.$router.push("/userAppInfotxs?token=" + this.getToken);
          }
        }
      } else {
        if (navigator.userAgent.indexOf("Android") > -1) {
          // tips.toast("即将上线，敬请期待");
          this.$point.eventId("down_app_news_100001");
          window.location =
            "http://news.haoyunba.com/apk/news_android.apk";
        } else {
          tips.toast("该软件付费后即可使用，请先购买会员");
          setTimeout(() => {
            this.$router.push("/pay");
          }, 2000);
        }

        return;
      }
      */
      if (navigator.userAgent.indexOf("Android") > -1) {
            // tips.toast("即将上线，敬请期待");
            this.$point.eventId("down_app_news_100001");
            window.location =
              "http://news.haoyunba.com/apk/news_android.apk";
          } else {
            this.$router.push("/userAppInfotxs?token=" + this.getToken);
          }
    }
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  }
};
</script>
<style  scoped>
#app {
  width: 100%;
  height: auto;
  min-height: 1344px;
}
.app-info {
  width: 100%;
  height: auto;
}
.app-info-s {
  width: 632px;
  height: 285px;
  display: flex;
  margin: 0 auto;
}

.app-info-logo {
  width: 122px;
  height: 122px;
}

.app-info-logo img {
  width: 122px;
  height: 122px;
}

.app-info-content {
  flex: 1;
  text-align: left;
  padding: 0px 0px 0px 36px;
}

.app-name {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 50px;
}

.app-desc {
  width: 474px;
  height: 115px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 0.5);
  line-height: 40px;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}

.app-info-content button {
  width: 210px;
  height: 48px;
  background: linear-gradient(90deg, #eeae91 0%, #f9dcc1 100%);
  border-radius: 24px;
  margin-top: 36px;
  border: none;
  font-size: 26px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 48px;
}

.app-info-right {
  width: 125px;
  height: 30px;
  background: url("../../assets/img/app-info-right@2x.png") no-repeat;
  background-size: 100% 100%;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(127, 86, 47, 1);
  line-height: 30px;
  position: absolute;
  right: 68px;
}

.clac-s {
  background: url("../../assets/img/img02.png");
  width: 750px;
  height: 850px;
  margin: 0 auto;
  background-size: 100% 100%;
}

.new-s {
  background: url("../../assets/img/img03.png");
  width: 750px;
  height: 918px;
  margin: 0 auto;
  background-size: 100% 100%;
}

.dkf {
  background: #2c3163;
  border-radius: 7px;
  border-radius: 7px;
  width: 690px;
  height: 728px;
  margin: 100px auto 20px;
  border: 1px solid #6a5951;
}
.dkf-s {
  padding: 60px 30px;
}

.info-s {
  width: 100%;
  height: auto;
  padding: 0;
  padding-top: 320px;
}

.info-s li {
  width: 175px;
  height: 200px;
  float: left;
  margin-left: 55px;
}

.info-s li {
  margin-top: 25px;
}

.new-s {
  padding-top: 40px;
}
.new-s ul li {
  margin-top: 30px;
}

.info-s li div {
  text-align: center;
}

.info-log {
  width: 116px;
  height: 116px;
  border-radius: 12px;
}
.info-s li button {
  background-image: linear-gradient(90deg, #eeb08e 4%, #f9dcc1 100%);
  border-radius: 12px;
  border-radius: 12px;
  width: 180px;
  height: 36px;
  border: none;
  margin: 15px 0 0 0;
  font-family: PingFangSC-Semibold;
  font-size: 20px;
  color: #702c03;
  letter-spacing: -0.05px;
  text-align: center;
  font-weight: 600;
}

.info-jb {
  position: relative;
  width: 50px;
  height: 30px;
  margin: -190px 0 0 126px;
}
.info-jb img {
  width: 100%;
  height: 100%;
}
.nunbutton {
  background: #cccccc;
}
</style>
 
 
 


// WEBPACK FOOTER //
// src/components/common/downAppListNew.vue